var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-center",attrs:{"id":"main-layout-public"}},[_c('NavBarDefault'),_c('div',{staticClass:"content-block-article"},[_vm._t("default")],2),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }